/**
 * This middleware sends analytics events based on
 * redux actions. It should be applied to the redux
 * store config.
 *
 * Using middleware allows decoupling the sending of
 * analytics events from the View/View Controllers (VVC).
 *
 * Note:
 * There is still an issue when the analytics event
 * being sent needs to access data from the redux store.
 * In this case, we want to use selectors. Unfortunately,
 * most of our redux selectors are co-located with the
 * View/View Controller (VVC) so this implies reaching down
 * into the VVC to import the selectors creating a not so
 * great coupling between this file and all the VVC files.
 * This may be ok but ideally we would move the global redux
 * state up to a global level and then importing these selectors
 * would not couple analytics to VVC.
 */
import { USER_INFO_SUCCESS } from 'redux/User';

import {
  initializeModsyFBPixel,
  userLoggedIn,
  userSignedUp
} from './analytics';

export const analyticsMiddleware = store => next => action => {
  // Watch out for the order of operations here.
  // We first apply the action to the store, and
  // then we process the analytics events.
  const result = next(action);

  // Process the analytics events.
  switch (action.type) {
    case USER_INFO_SUCCESS: {
      const { email, from } = action.payload;

      if (email && from) {
        // reinitialize facebook pixel with email information
        initializeModsyFBPixel({
          em: email.toLowerCase()
        })(store.dispatch, store.getState);

        // track Login
        if (from === 'Login') {
          userLoggedIn(action.payload)(store.dispatch, store.getState);
        }

        // track SignUp
        if (from === 'Style Quiz' || from === 'Start Project') {
          userSignedUp(action.payload)(store.dispatch, store.getState);
        }
      }
      break;
    }

    default:
      break;
  }

  return result;
};
